<template>
  <div class="home-page">
    <div class="home-page-container">
      <div class="banner">
        <div class="banner-content">
          <div class="platform-name">{{ version }} 开放平台</div>
          <div class="platform-description">{{ description }}</div>
        </div>
        <!-- <img v-if="isV5" class="banner-img" src="../assets/imgs/banner-index.jpg" alt="致远开放平台" /> -->
      </div>
      <div class="search-module">
        <SearchGlobal></SearchGlobal>
      </div>
      <!-- 一体化开发服务支持 -->
      <GuideCmp v-if="isV5" @openProject="openProject"></GuideCmp>
    </div>
    <Footer v-if="$route.path=='/home'"></Footer>
  </div>
</template>
<script>
// import HotTools from "./toolsBaseCmp/cmps/HotTools.vue";
import topFaqList from "../../public/json/defaultFaq.json";
import hotToolsList from "../../public/json/defaultFaq.json";
import GuideCmp from "./index/GuideCmp.vue";

import eventBus from '@/utils/eventBus'
import { getCookie } from "@/utils/common";
import SearchGlobal from "./index/SearchGlobal.vue";
import Footer from "./Footer.vue";

export default {
  name: "home-page",
  data() {
    return {
      categories: [],
      topFaqList: topFaqList,
      hotToolsList: hotToolsList,
      loginKey: "",
    };
  },
  components: {
    GuideCmp,
    SearchGlobal,
    Footer
  },
  computed:{
    version(){
      return window.localStorage.getItem("openSeeyonVersion") || 'V5'
    },
    isV5(){
      return this.version == 'V5'
    },
    description(){
      return this.isV5 ? '秉承开放理念，面向公司、伙伴与第三方推出的能力开放及资源共享平台，全系统已接入智能检索能力' : '聚焦技术文档与操作指南的共享，提供全面细致的文档资源，赋能V8参与者实现无缝集成与卓越系统运维'
    },
  },
  created() {
    eventBus.$on("loginSuccess", () => {
      // 监听登录消息
      this.loginKey = getCookie("loginKey");
    });
    // 判断用户是否登录过
    this.loginKey = getCookie("loginKey");
  },
  methods: {
    openProject() {
      // 上传后放开
      var strcookie = document.cookie; //获取cookie字符串
      var arrcookie = strcookie.split("; "); //分割
      var userName;
      var ticket;
      var authenicationState;
      for (var i = 0; i < arrcookie.length; i++) {
        var arr = arrcookie[i].split("=");
        if (arr[0] == "userName") {
          userName = arr[1];
        }
        if (arr[0] == "ticket") {
          ticket = arr[1];
        }
        if (arr[0] == "authenicationState") {
          authenicationState = arr[1];
        }
      }
      if (userName == undefined || ticket == undefined) {
        window.open("http://open.seeyon.com/seeyonbbs/?user-login.htm&from=open");
      } else if (authenicationState == 0 || authenicationState == undefined) {
        window.open("http://open.seeyon.com/seeyonbbs/?my-authentication.htm");
      } else {
        window.open("http://open.seeyon.com/seeyonbbs/?my-authentication.htm?sso_flag=success");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.home-page {
  width: 100%;
  background: #fff;
  height: calc(100% - 60px);

  &-container{
    padding: 0 11%;
    width: 100%;
    height: 100%;
    background-color: #fff;
    background: 50% 10% / cover no-repeat url("../assets/imgs/home-bg.png");
    overflow-y: auto;
  }
}
.footer{
  position: fixed;
  height: 60px;
  left: 0;
  right: 0;
  bottom: 0;
}

.banner {
  position: relative;
  height: 26%;
  .banner-img {
    width: 100%;
  }
  &-content {
    position: absolute;
    left: 0;
    top: 30%;
  }
  .platform-name{
    font-size: 50px;
    font-weight: Bold;
    color: #000000;
  }
  .platform-description{
    font-size: 20px;
    font-weight: Regular;
    color: #333;
    margin-top: 2%;
    max-width: 40vw;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

.search-module {
  margin-top: 5%;
}

@media screen and (max-width: 1730px) {

  .home-page-container { 
    padding: 0 10%;
  }
  .banner {
    .platform-name{
      font-size: 42px;
    }
  }
}

@media screen and (max-width: 1440px) {
  
  .home-page-container { 
    padding: 0 8%;
  }
  
  .banner {
    .platform-name{
      font-size: 34px;
    }
    .platform-description{
      margin-top: 2%;
    }
  }
}

@media screen and (max-width: 1240px) {
  
  .home-page-container { 
    padding: 0 6%;
    background: 70% 30% / cover no-repeat url("../assets/imgs/home-bg-m.png");
  }
}
@media screen and (max-width: 1024px) {
  .home-page-container { 
    padding: 0 6%;
  }
  .banner {
    .platform-name{
      font-size: 34px;
    }
    .platform-description{
      margin-top: 2%;
      font-size: 20px;
    }
  }
}

@media screen and (max-width: 824px) {
  
  .banner {
    .platform-name{
      font-size: 24px;
    }
    .platform-description{
      margin-top: 1%;
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 624px) {
  .home-page-container { 
    background-position: 70% 60%;
  }
  .banner {
    height: 24%;
    &-content {
      top: 30%;
    }
    .platform-description{
      font-size: 12px;
      margin-top: 2%;
    }
  }
}
@media screen and (max-width: 500px) {
  .banner {
    &-content {
      top: 30%;
    }
    .platform-description{
      max-width: 49vw;
    }
  }
}
@media screen and (max-width: 375px) {
  .home-page-container { 
    background-position: 70% 34%;
  }
}
</style>